<template lang="html">
  <div class="episode">
    <img :src="require('../assets/beers/beer_id-' + beer.id + '.jpg')" alt="">
    <div class="content">

      <h2 class="title">{{beer.name}}</h2>
      <div class="bot">
        <p class="meta">abv. {{beer.abv}}%</p>
        <p class="meta">kr. {{beer.price.toFixed(2)}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    beer: Object
  }
}
</script>

<style lang="css" scoped>

.episode {
    width: 100%;

    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.3);
    text-align: left;
    margin-bottom: 20px;
    display: flex;
    height: 100px;
    position: relative;
}

.content{
  padding: 10px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
}

.meta {
  font-size: 0.8em;
}

.bot {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}


img {
  width: 100px;
  object-fit: cover;
}


h2{
  margin: 0;
  padding: 0;
  font-size: 1.2em;
}
p{
  margin: 0;
}

</style>
